<app-table class="reducedTable notifications" [apiService]="apiService" [tableService]="tableService" [dataService]="dataService">
</app-table>